import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: '쿠키를 사용합니다',
    description:
      '이 환경을 제공하기 위해 쿠키 및 유사 기술을 사용합니다. 반드시 필요한 쿠키는 항상 활성화되어 있습니다.',
    allow_label: '모든 쿠키 허용',
    reject_label: '필수 쿠키만',
    settings_label: '쿠키 설정',
    policy_link_label: '개인정보 및 쿠키 정책',
    categories_label: '카테고리',
    always_on_label: '항상 활성화',
    required_label: '필수',
    save_preferences_label: '설정 저장',
    close_label: '닫기',
    allow_all_optional_categories_label: '모든 선택 카테고리 허용',
    save_error: '개인정보 설정을 저장할 수 없습니다. 다시 시도해 주세요.'
  },
  categories: {
    strictly_necessary: { name: '필수', purpose: '이 환경을 제공하는 데 필요하며 비활성화할 수 없습니다.' },
    analytics: { name: '분석', purpose: '성능 개선을 위해 방문자가 이 환경을 사용하는 방식을 측정합니다.' },
    marketing: { name: '마케팅', purpose: '주최자가 선택한 광고와 마케팅을 지원합니다.' }
  }
};

export default locale;
